import { useCallback, useState } from 'react';

import { SyncStorageKey, syncStorage } from 'utils/environment/sync-storage';

import { AutoSelectPromptStateReturnType } from '../types';

/**
 * Prompt open state and cooldown timestamp writes.
 * Silent AutoSelectStore also writes AUTO_SELECT_STORE_TIMESTAMP (not a session latch).
 */
export const useAutoSelectPromptState = (): AutoSelectPromptStateReturnType => {
  const [isOpen, setIsOpen] = useState(false);

  const updateAutoSelectTimestamp = useCallback(() => {
    syncStorage.setNumber(SyncStorageKey.AUTO_SELECT_STORE_TIMESTAMP, Date.now());
  }, []);

  return {
    isOpen,
    setIsOpen,
    updateAutoSelectTimestamp,
  };
};
